import { useEffect, useState } from "react";
import type { FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Alerta, Botao, Campo, Cartao } from "@plantus/ui";

import { usarSessao } from "./ProvedorDeSessao";
import { mensagemDeLogin } from "./mensagens";
import { Moldura } from "../layout/Moldura";

interface EstadoDeOrigem {
  de?: string;
}

export function PaginaEntrar() {
  const { estado, entrar } = usarSessao();
  const navegar = useNavigate();
  const local = useLocation();

  const [identificador, definirIdentificador] = useState("");
  const [senha, definirSenha] = useState("");
  const [manterConectado, definirManterConectado] = useState(false);
  const [erro, definirErro] = useState<string | null>(null);
  const [enviando, definirEnviando] = useState(false);

  const destino = (local.state as EstadoDeOrigem | null)?.de ?? "/";

  useEffect(() => {
    if (estado.tipo === "parcial") {
      navegar("/entrar/codigo", { replace: true, state: { de: destino } });
    }
  }, [estado.tipo, navegar, destino]);

  if (estado.tipo === "autenticado") {
    return <Navigate to={destino} replace />;
  }

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    definirErro(null);
    definirEnviando(true);
    try {
      await entrar(identificador, senha, manterConectado);
      // Se o segundo fator estiver pendente, o efeito acima redireciona.
    } catch (falha) {
      definirErro(mensagemDeLogin(falha));
    } finally {
      definirEnviando(false);
    }
  }

  return (
    <Moldura>
      <Cartao titulo="Entrar no sistema">
        <h1 className="entrada__titulo">Entrar</h1>

        <form onSubmit={enviar} noValidate>
          {erro !== null && <Alerta tom="erro">{erro}</Alerta>}

          <div className="entrada__campos">
            <Campo
              rotulo="E-mail ou usuário"
              name="identificador"
              // `username` e não `email`: o campo aceita os dois, e o
              // gerenciador de senha guarda o que a pessoa realmente digita.
              autoComplete="username"
              autoFocus
              required
              value={identificador}
              onChange={(e) => definirIdentificador(e.target.value)}
            />

            <Campo
              rotulo="Senha"
              type="password"
              name="senha"
              autoComplete="current-password"
              required
              value={senha}
              onChange={(e) => definirSenha(e.target.value)}
            />

            <label className="entrada__lembrar">
              <input
                type="checkbox"
                checked={manterConectado}
                onChange={(e) => definirManterConectado(e.target.checked)}
              />
              <span>Manter conectado</span>
            </label>
          </div>

          <Botao type="submit" largo carregando={enviando}>
            Entrar
          </Botao>
        </form>
      </Cartao>
    </Moldura>
  );
}
